import {
  Alert,
  Center,
  DrawerBody,
  DrawerHeader,
  Flex,
  HStack,
  Spinner,
  Text,
} from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { trpcAdmin } from '@duke-hq/app-admin-web/lib/trpcAdmin';
import { SiteForm } from './SiteForm';
import { LocationError } from './LocationError';
import { SitesLocationsURLParams } from './types';

export function SiteLocationsDetails() {
  const { providerId, siteId } = useParams<SitesLocationsURLParams>();
  if (!providerId || !siteId) {
    return <LocationError message={t`An error occurred, providerId and siteId are required.`} />;
  }

  const { data: site, isLoading } = trpcAdmin.providers.locations.getSiteLocation.useQuery(
    {
      providerId,
      id: siteId,
    },
    { enabled: Boolean(!!providerId && !!siteId) },
  );

  if (isLoading || !site) {
    return (
      <Center h="100vh">
        <Spinner size="xl" />
      </Center>
    );
  }

  if (!site) {
    return (
      <Alert>
        <Trans>No site found</Trans>
      </Alert>
    );
  }

  return (
    <Flex flexDirection="column" w="100%" h="100%">
      <DrawerHeader
        borderBottomWidth="1px"
        borderBottomColor="border.default"
        p={{ base: 2, md: 4 }}
      >
        <HStack justify="space-between" alignContent="center">
          <HStack align="start" h="full" alignSelf="stretch">
            <Text fontSize="lg" fontWeight="semibold">
              <Trans>Site details</Trans>
            </Text>
          </HStack>
        </HStack>
      </DrawerHeader>

      <DrawerBody p="0" border="none" m="0" paddingInline="0 !important">
        <SiteForm site={site} />
      </DrawerBody>
    </Flex>
  );
}
